import * as React from "react"
import { useRecordContext,  FieldProps } from "react-admin"
import { CronWidget } from "components/ui/forms"

interface CrontabFieldProps extends FieldProps {
  source: string
}

const CrontabField: React.FC<CrontabFieldProps> = (props) => {
  const { source } = props
  const record = useRecordContext(props)
  
  if (!record || !record[source]) return null
  
  const crontabValue: string = record[source]
  
  return (
    <CronWidget source={source} defaultValue={crontabValue} readOnly hideBox />
  )
}

export default CrontabField
